<template>
    <div class="min-h-screen">
        <!-- 页面横幅 -->
        <Banner :title="t('contact.banner.title')" :subtitle="t('contact.banner.subtitle')" />

        <!-- 联系方式 -->
        <section class="py-20">
            <div class="container mx-auto px-4">
                <div class="text-center mb-12">
                    <h2 class="text-3xl font-bold text-[#005005] mb-4 border-b-4 border-[#005005] inline-block pb-2">{{ t('contact.contactInfo.title') }}</h2>
                    <p class="text-[#8d6e63]">{{ t('contact.contactInfo.subtitle') }}</p>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    <div class="bg-white p-8 rounded-lg shadow-lg text-center">
                        <div class="text-4xl text-[#005005] mb-6">
                            <i class="fas fa-map-marker-alt"></i>
                        </div>
                        <h3 class="text-xl font-bold text-[#005005] mb-4">{{ t('contact.contactInfo.address.title') }}</h3>
                        <p class="text-[#212121]">{{ t('contact.contactInfo.address.content') }}</p>
                        <p class="text-[#212121]">{{ t('contact.contactInfo.address.postcode') }}</p>
                    </div>
                    <div class="bg-white p-8 rounded-lg shadow-lg text-center">
                        <div class="text-4xl text-[#005005] mb-6">
                            <i class="fas fa-phone-alt"></i>
                        </div>
                        <h3 class="text-xl font-bold text-[#005005] mb-4">{{ t('contact.contactInfo.phone.title') }}</h3>
                        <p class="text-[#212121]">{{ t('contact.contactInfo.phone.main') }}</p>
                        <p class="text-[#212121]">{{ t('contact.contactInfo.phone.service') }}</p>
                    </div>
                    <div class="bg-white p-8 rounded-lg shadow-lg text-center">
                        <div class="text-4xl text-[#005005] mb-6">
                            <i class="fas fa-envelope"></i>
                        </div>
                        <h3 class="text-xl font-bold text-[#005005] mb-4">{{ t('contact.contactInfo.email.title') }}</h3>
                        <p class="text-[#212121]">{{ t('contact.contactInfo.email.service') }}</p>
                        <p class="text-[#212121]">{{ t('contact.contactInfo.email.inquiry') }}</p>
                    </div>
                    <div class="bg-white p-8 rounded-lg shadow-lg text-center">
                        <div class="text-4xl text-[#005005] mb-6">
                            <i class="fas fa-clock"></i>
                        </div>
                        <h3 class="text-xl font-bold text-[#005005] mb-4">{{ t('contact.contactInfo.workingHours.title') }}</h3>
                        <p class="text-[#212121]">{{ t('contact.contactInfo.workingHours.weekday') }}</p>
                        <p class="text-[#212121]">{{ t('contact.contactInfo.workingHours.holiday') }}</p>
                    </div>
                </div>
            </div>
        </section>

        <!-- 在线咨询 -->
        <section class="bg-gray-50 py-20">
            <div class="container mx-auto px-4">
                <div class="text-center mb-12">
                    <h2 class="text-3xl font-bold text-[#005005] mb-4 border-b-4 border-[#005005] inline-block pb-2">{{ t('contact.inquiry.title') }}</h2>
                    <p class="text-[#8d6e63]">{{ t('contact.inquiry.subtitle') }}</p>
                </div>
                <div class="grid grid-cols-1 lg:grid-cols-3 gap-8">
                    <div class="lg:col-span-2">
                        <form id="contact-form" @submit.prevent="handleSubmit" class="bg-white p-8 rounded-lg shadow-lg">
                            <div class="mb-6">
                                <label for="name" class="block text-[#8d6e63] font-medium mb-2">{{ t('contact.inquiry.form.name') }} <span class="text-red-500">*</span></label>
                                <input type="text" id="name" v-model="formData.name" required
                                    class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#005005]">
                            </div>
                            <div class="mb-6">
                                <label for="company" class="block text-[#8d6e63] font-medium mb-2">{{ t('contact.inquiry.form.company') }}</label>
                                <input type="text" id="company" v-model="formData.company"
                                    class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#005005]">
                            </div>
                            <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                                <div>
                                    <label for="email" class="block text-[#8d6e63] font-medium mb-2">{{ t('contact.inquiry.form.email') }} <span class="text-red-500">*</span></label>
                                    <input type="email" id="email" v-model="formData.email" required
                                        class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#005005]">
                                </div>
                                <div>
                                    <label for="phone" class="block text-[#8d6e63] font-medium mb-2">{{ t('contact.inquiry.form.phone') }} <span class="text-red-500">*</span></label>
                                    <input type="tel" id="phone" v-model="formData.phone" required
                                        class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#005005]">
                                </div>
                            </div>
                            <div class="mb-6">
                                <label for="subject" class="block text-[#8d6e63] font-medium mb-2">{{ t('contact.inquiry.form.subject') }} <span class="text-red-500">*</span></label>
                                <select id="subject" v-model="formData.subject" required
                                    class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#005005]">
                                    <option value="">{{ t('contact.inquiry.form.subjectPlaceholder') }}</option>
                                    <option value="product">{{ t('contact.inquiry.form.subjects.product') }}</option>
                                    <option value="price">{{ t('contact.inquiry.form.subjects.price') }}</option>
                                    <option value="technical">{{ t('contact.inquiry.form.subjects.technical') }}</option>
                                    <option value="cooperation">{{ t('contact.inquiry.form.subjects.cooperation') }}</option>
                                    <option value="other">{{ t('contact.inquiry.form.subjects.other') }}</option>
                                </select>
                            </div>
                            <div class="mb-6">
                                <label for="message" class="block text-[#8d6e63] font-medium mb-2">{{ t('contact.inquiry.form.message') }} <span class="text-red-500">*</span></label>
                                <textarea id="message" v-model="formData.message" rows="6" required
                                    class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#005005]"></textarea>
                            </div>
                            <div>
                                <button type="submit" :disabled="isSubmitting"
                                    class="w-full bg-[#8d6e63] text-white py-3 px-6 rounded-md hover:bg-[#5f4339] focus:outline-none focus:ring-2 focus:ring-[#005005] focus:ring-offset-2 disabled:bg-[#8d6e63]/50 disabled:cursor-not-allowed transition-colors">
                                    <i v-if="isSubmitting" class="fas fa-spinner fa-spin mr-2"></i>
                                    {{ isSubmitting ? t('contact.inquiry.form.submitting') : t('contact.inquiry.form.submit') }}
                                </button>
                            </div>
                        </form>
                    </div>
                    <div class="space-y-6">
                        <div class="bg-white p-6 rounded-lg shadow-lg">
                            <h3 class="text-xl font-bold text-[#005005] mb-4">{{ t('contact.inquiry.sales.title') }}</h3>
                            <ul class="space-y-3">
                                <li class="flex justify-between">
                                    <span class="text-[#8d6e63]">{{ t('contact.inquiry.sales.domesticRawPaper') }}：</span>
                                    <span class="text-[#212121]">0831-3309515</span>
                                </li>
                                <li class="flex justify-between">
                                    <span class="text-[#8d6e63]">{{ t('contact.inquiry.sales.domesticFinishedPaper') }}：</span>
                                    <span class="text-[#212121]">0831-3309698</span>
                                </li>
                                <li class="flex justify-between">
                                    <span class="text-[#8d6e63]">{{ t('contact.inquiry.sales.international') }}：</span>
                                    <span class="text-[#212121]">0831-3309530</span>
                                </li>
                                <li class="flex justify-between">
                                    <span class="text-[#8d6e63]">{{ t('contact.inquiry.sales.email') }}：</span>
                                    <span class="text-[#212121]">sales@yibinpaper.com</span>
                                </li>
                            </ul>
                        </div>
                        <div class="bg-white p-6 rounded-lg shadow-lg">
                            <h3 class="text-xl font-bold text-[#005005] mb-4">{{ t('contact.inquiry.afterSales.title') }}</h3>
                            <ul class="space-y-3">
                                <li class="flex justify-between">
                                    <span class="text-[#8d6e63]">{{ t('contact.inquiry.afterSales.hotlineRawPaper') }}：</span>
                                    <span class="text-[#212121]">0831-3309515</span>
                                </li>
                                <li class="flex justify-between">
                                    <span class="text-[#8d6e63]">{{ t('contact.inquiry.afterSales.hotlineFinishedPaper') }}：</span>
                                    <span class="text-[#212121]">0831-3309698</span>
                                </li>
                                <li class="flex justify-between">
                                    <span class="text-[#8d6e63]">{{ t('contact.inquiry.afterSales.email') }}：</span>
                                    <span class="text-[#212121]">zhongxia@yb-zy.com</span>
                                </li>
                            </ul>
                        </div>
                        <div class="bg-white p-6 rounded-lg shadow-lg">
                            <h3 class="text-xl font-bold text-[#005005] mb-4">{{ t('contact.inquiry.social.title') }}</h3>
                            <div class="flex justify-center space-x-8">
                                <a href="#" class="text-[#005005] hover:text-[#005005]/70 transition-colors">
                                    <i class="fab fa-weixin text-2xl mb-2"></i>
                                    <span class="block text-sm">{{ t('contact.inquiry.social.wechat') }}</span>
                                </a>
                                <a href="#" class="text-[#005005] hover:text-[#005005]/70 transition-colors">
                                    <i class="fab fa-weibo text-2xl mb-2"></i>
                                    <span class="block text-sm">{{ t('contact.inquiry.social.weibo') }}</span>
                                </a>
                                <a href="#" class="text-[#005005] hover:text-[#005005]/70 transition-colors">
                                    <i class="fab fa-linkedin text-2xl mb-2"></i>
                                    <span class="block text-sm">{{ t('contact.inquiry.social.linkedin') }}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- 公司位置 -->
        <section class="py-20">
            <div class="container mx-auto px-4">
                <div class="text-center mb-12">
                    <h2 class="text-3xl font-bold text-[#005005] mb-4 border-b-4 border-[#005005] inline-block pb-2">{{ t('contact.location.title') }}</h2>
                    <p class="text-[#8d6e63]">{{ t('contact.location.subtitle') }}</p>
                </div>
                <div class="mb-12">
                    <img src="/images/company/6.jpg" :alt="t('contact.location.mapAlt')" class="w-full rounded-lg shadow-lg">
                </div>
                <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
                    <div class="flex items-start">
                        <div class="text-2xl text-[#005005] mr-4">
                            <i class="fas fa-subway"></i>
                        </div>
                        <div>
                            <h3 class="text-xl font-bold text-[#005005] mb-2">{{ t('contact.location.transport.public.title') }}</h3>
                            <p class="text-[#212121]">{{ t('contact.location.transport.public.content') }}</p>
                        </div>
                    </div>
                    <div class="flex items-start">
                        <div class="text-2xl text-[#005005] mr-4">
                            <i class="fas fa-car"></i>
                        </div>
                        <div>
                            <h3 class="text-xl font-bold text-[#005005] mb-2">{{ t('contact.location.transport.driving.title') }}</h3>
                            <p class="text-[#212121]">{{ t('contact.location.transport.driving.content') }}</p>
                        </div>
                    </div>
                    <div class="flex items-start">
                        <div class="text-2xl text-[#005005] mr-4">
                            <i class="fas fa-plane"></i>
                        </div>
                        <div>
                            <h3 class="text-xl font-bold text-[#005005] mb-2">{{ t('contact.location.transport.airport.title') }}</h3>
                            <p class="text-[#212121]">{{ t('contact.location.transport.airport.content') }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- 全球办事处 -->
        <!-- <section class="bg-gray-50 py-20">
            <div class="container mx-auto px-4">
                <div class="text-center mb-12">
                    <h2 class="text-3xl font-bold text-[#005005] mb-4 border-b-4 border-[#005005] inline-block pb-2">{{ t('contact.offices.title') }}</h2>
                    <p class="text-[#8d6e63]">{{ t('contact.offices.subtitle') }}</p>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    <div class="bg-white p-6 rounded-lg shadow-lg text-center">
                        <div class="mb-4">
                            <img src="/images/36.jfif" :alt="t('contact.offices.china.flagAlt')" class="w-32 h-20 object-cover mx-auto rounded">
                        </div>
                        <h3 class="text-xl font-bold text-[#005005] mb-2">{{ t('contact.offices.china.title') }}</h3>
                        <p class="text-[#212121]">{{ t('contact.offices.china.address') }}</p>
                        <p class="text-[#212121]">{{ t('contact.offices.china.phone') }}</p>
                    </div>
                    <div class="bg-white p-6 rounded-lg shadow-lg text-center">
                        <div class="mb-4">
                            <img src="/images/42.jfif" :alt="t('contact.offices.usa.flagAlt')" class="w-32 h-20 object-cover mx-auto rounded">
                        </div>
                        <h3 class="text-xl font-bold text-[#005005] mb-2">{{ t('contact.offices.usa.title') }}</h3>
                        <p class="text-[#212121]">{{ t('contact.offices.usa.address') }}</p>
                        <p class="text-[#212121]">{{ t('contact.offices.usa.phone') }}</p>
                    </div>
                    <div class="bg-white p-6 rounded-lg shadow-lg text-center">
                        <div class="mb-4">
                            <img src="/images/38.jfif" :alt="t('contact.offices.japan.flagAlt')" class="w-32 h-20 object-cover mx-auto rounded">
                        </div>
                        <h3 class="text-xl font-bold text-[#005005] mb-2">{{ t('contact.offices.japan.title') }}</h3>
                        <p class="text-[#212121]">{{ t('contact.offices.japan.address') }}</p>
                        <p class="text-[#212121]">{{ t('contact.offices.japan.phone') }}</p>
                    </div>
                    <div class="bg-white p-6 rounded-lg shadow-lg text-center">
                        <div class="mb-4">
                            <img src="/images/40.jfif" :alt="t('contact.offices.europe.flagAlt')" class="w-32 h-20 object-cover mx-auto rounded">
                        </div>
                        <h3 class="text-xl font-bold text-[#005005] mb-2">{{ t('contact.offices.europe.title') }}</h3>
                        <p class="text-[#212121]">{{ t('contact.offices.europe.address') }}</p>
                        <p class="text-[#212121]">{{ t('contact.offices.europe.phone') }}</p>
                    </div>
                    <div class="bg-white p-6 rounded-lg shadow-lg text-center">
                        <div class="mb-4">
                            <img src="/images/43.jfif" :alt="t('contact.offices.singapore.flagAlt')" class="w-32 h-20 object-cover mx-auto rounded">
                        </div>
                        <h3 class="text-xl font-bold text-[#005005] mb-2">{{ t('contact.offices.singapore.title') }}</h3>
                        <p class="text-[#212121]">{{ t('contact.offices.singapore.address') }}</p>
                        <p class="text-[#212121]">{{ t('contact.offices.singapore.phone') }}</p>
                    </div>
                </div>
            </div>
        </section> -->

        <!-- 常见问题 -->
        <section class="py-20">
            <div class="container mx-auto px-4">
                <div class="text-center mb-12">
                    <h2 class="text-3xl font-bold text-[#005005] mb-4 border-b-4 border-[#005005] inline-block pb-2">{{ t('contact.faq.title') }}</h2>
                    <p class="text-[#8d6e63]">{{ t('contact.faq.subtitle') }}</p>
                </div>
                <div class="max-w-3xl mx-auto">
                    <div v-for="(faq, index) in faqs" :key="index" 
                         class="border border-gray-200 rounded-lg mb-4 overflow-hidden"
                         :class="{ 'bg-gray-50': faq.isActive }">
                        <div class="p-4 cursor-pointer flex justify-between items-center"
                             @click="toggleFaq(index)">
                            <h3 class="text-lg font-semibold text-[#005005]">{{ faq.question[locale] }}</h3>
                            <span class="text-[#005005]">
                                <i :class="faq.isActive ? 'fas fa-minus' : 'fas fa-plus'"></i>
                            </span>
                        </div>
                        <div class="px-4 transition-all duration-500 ease-in-out overflow-hidden"
                             :style="{ maxHeight: faq.isActive ? faq.answerHeight + 'px' : '0' }">
                            <div class="py-4 text-[#212121]" v-html="faq.answer[locale]" ref="answerRefs"></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <CTA
          :title="t('contact.cta.title')"
          :description="t('contact.cta.description')"
          :buttonText="t('contact.cta.buttonText')"
          buttonLink="#contact-form"
          backgroundImage="/images/56.png"
        />
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import Banner from '../components/Banner.vue'
import CTA from '../components/CTA.vue'

const { t, locale } = useI18n()

// 表单数据
const formData = ref({
    name: '',
    company: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
})

const isSubmitting = ref(false)

interface FAQ {
    question: {
        zh: string
        en: string
        ja: string
        Russian: string
        Malay: string
        [key: string]: string
    }
    answer: {
        zh: string
        en: string
        ja: string
        Russian: string
        Malay: string
        [key: string]: string
    }
    isActive: boolean
    answerHeight: number
}

// FAQ数据
const faqs = ref<FAQ[]>([
    {
        question: {
            zh: '如何获取产品样品？',
            en: 'How to get product samples?',
            ja: '製品サンプルの入手方法は？',
            Russian: '製品サンプルの入手方法は？',
            Malay: '製品サンプルの入手方法は？'
        },
        answer: {
            zh: `
                <p>您可以通过以下方式获取产品样品：</p>
                <ol>
                    <li>填写上方的在线咨询表格，选择"产品咨询"，并在咨询内容中注明需要样品的产品型号和用途；</li>
                    <li>直接联系我们的销售团队，电话：0831-3309689；</li>
                    <li>发送邮件至 sales@yibinpaper.com，详细说明您的需求。</li>
                </ol>
                <p>收到您的请求后，我们的客服人员将在1-2个工作日内与您联系，确认样品发送事宜。</p>
            `,
            en: `
                <p>You can obtain product samples through the following methods:</p>
                <ol>
                    <li>Fill out the online inquiry form above, select "Product Inquiry", and specify the product model and intended use in the inquiry content;</li>
                    <li>Contact our sales team directly at 0831-3309689;</li>
                    <li>Send an email to sales@yibinpaper.com with detailed requirements.</li>
                </ol>
                <p>After receiving your request, our customer service staff will contact you within 1-2 business days to confirm sample delivery arrangements.</p>
            `,
            ja: `
                <p>製品サンプルは以下の方法で入手できます：</p>
                <ol>
                    <li>上記のオンラインお問い合わせフォームに記入し、「製品お問い合わせ」を選択し、サンプルが必要な製品モデルと用途を明記してください；</li>
                    <li>営業チームに直接お電話ください：0831-3309689；</li>
                    <li>sales@yibinpaper.com にメールで詳細な要件を送信してください。</li>
                </ol>
                <p>ご要望を受け取り次第、カスタマーサービス担当者が1-2営業日以内にご連絡し、サンプル発送の手配を確認いたします。</p>
            `,
            Russian: `
                <p>製品サンプルは以下の方法で入手できます：</p>
                <ol>
                    <li>上記のオンラインお問い合わせフォームに記入し、「製品お問い合わせ」を選択し、サンプルが必要な製品モデルと用途を明記してください；</li>
                    <li>営業チームに直接お電話ください：0831-3309689；</li>
                    <li>sales@yibinpaper.com にメールで詳細な要件を送信してください。</li>
                </ol>
                <p>ご要望を受け取り次第、カスタマーサービス担当者が1-2営業日以内にご連絡し、サンプル発送の手配を確認いたします。</p>
            `,
            Malay: `
                <p>製品サンプルは以下の方法で入手できます：</p>
                <ol>
                    <li>上記のオンラインお問い合わせフォームに記入し、「製品お問い合わせ」を選択し、サンプルが必要な製品モデルと用途を明記してください；</li>
                    <li>営業チームに直接お電話ください：0831-3309689；</li>
                    <li>sales@yibinpaper.com にメールで詳細な要件を送信してください。</li>
                </ol>
                <p>ご要望を受け取り次第、カスタマーサービス担当者が1-2営業日以内にご連絡し、サンプル発送の手配を確認いたします。</p>
            `
        },
        isActive: false,
        answerHeight: 0
    },
    {
        question: {
            zh: '产品是否可以定制？',
            en: 'Can products be customized?',
            ja: '製品のカスタマイズは可能ですか？',
            Russian: '产品是否可以定制？',
            Malay: '产品是否可以定制？'
        },
        answer: {
            zh: `
                <p>是的，我们提供产品定制服务，可根据客户需求定制产品规格、尺寸、颜色、包装等。定制产品需满足一定的起订量，具体请联系我们的销售团队进行咨询。</p>
            `,
            en: `
                <p>Yes, we provide product customization services. We can customize product specifications, dimensions, colors, packaging, etc. according to customer requirements. Customized products require a minimum order quantity. Please contact our sales team for specific details.</p>
            `,
            ja: `
                <p>はい、製品のカスタマイズサービスを提供しています。お客様のご要望に応じて、製品の仕様、寸法、色、包装などをカスタマイズできます。カスタマイズ製品には最小注文数量が必要です。詳細は営業チームにお問い合わせください。</p>
            `,
            Russian: `
                <p>是的，我们提供产品定制服务，可根据客户需求定制产品规格、尺寸、颜色、包装等。定制产品需满足一定的起订量，具体请联系我们的销售团队进行咨询。</p>
            `,
            Malay: `
                <p>是的，我们提供产品定制服务，可根据客户需求定制产品规格、尺寸、颜色、包装等。定制产品需满足一定的起订量，具体请联系我们的销售团队进行咨询。</p>
            `
        },
        isActive: false,
        answerHeight: 0
    },
    {
        question: {
            zh: '如何成为宜宾纸业的代理商？',
            en: 'How to become a Yibin Paper agent?',
            ja: '宜賓紙業の代理店になるには？',
            Russian: '如何成为宜宾纸业的代理商？',
            Malay: '如何成为宜宾纸业的代理商？'
        },
        answer: {
            zh: `
                <p>如您有意向成为我们的代理商，请发送合作意向至 ybzy@yb-zy.com，邮件中请包含以下信息：</p>
                <ul>
                    <li>公司基本情况介绍</li>
                    <li>目标市场和客户群体</li>
                    <li>销售渠道和资源</li>
                    <li>合作预期</li>
                </ul>
                <p>我们的业务发展团队将评估您的申请，并在10个工作日内回复。</p>
            `,
            en: `
                <p>If you are interested in becoming our agent, please send your cooperation intention to ybzy@yb-zy.com. The email should include the following information:</p>
                <ul>
                    <li>Company profile</li>
                    <li>Target market and customer base</li>
                    <li>Sales channels and resources</li>
                    <li>Cooperation expectations</li>
                </ul>
                <p>Our business development team will evaluate your application and respond within 10 business days.</p>
            `,
            ja: `
                <p>当社の代理店になることにご興味をお持ちの方は、ybzy@yb-zy.com まで協力意向をお送りください。メールには以下の情報を含めてください：</p>
                <ul>
                    <li>会社概要</li>
                    <li>ターゲット市場と顧客層</li>
                    <li>販売チャネルとリソース</li>
                    <li>協力への期待</li>
                </ul>
                <p>ビジネス開発チームがご申請を評価し、10営業日以内に回答いたします。</p>
            `,
            Russian: `
                <p>如您有意向成为我们的代理商，请发送合作意向至 ybzy@yb-zy.com，邮件中请包含以下信息：</p>
                <ul>
                    <li>公司基本情况介绍</li>
                    <li>目标市场和客户群体</li>
                    <li>销售渠道和资源</li>
                    <li>合作预期</li>
                </ul>
                <p>我们的业务发展团队将评估您的申请，并在10个工作日内回复。</p>
            `,
            Malay: `
                <p>如您有意向成为我们的代理商，请发送合作意向至 ybzy@yb-zy.com，邮件中请包含以下信息：</p>
                <ul>
                    <li>公司基本情况介绍</li>
                    <li>目标市场和客户群体</li>
                    <li>销售渠道和资源</li>
                    <li>合作预期</li>
                </ul>
                <p>我们的业务发展团队将评估您的申请，并在10个工作日内回复。</p>
            `
        },
        isActive: false,
        answerHeight: 0
    },
    {
        question: {
            zh: '产品是否有环保认证？',
            en: 'Do products have environmental certifications?',
            ja: '製品は環境認証を取得していますか？',
            Russian: '产品是否有环保认证？',
            Malay: '产品是否有环保认证？'
        },
        answer: {
            zh: `
                <p>是的，我们的产品已获得多项国内外环保认证，包括FSC认证、ISO 14001环境管理体系认证、中国环境标志产品认证等。您可以在产品详情页查看具体产品的认证信息，或联系我们的客服获取认证证书副本。</p>
            `,
            en: `
                <p>Yes, our products have obtained multiple domestic and international environmental certifications, including FSC certification, ISO 14001 Environmental Management System certification, and China Environmental Label Product certification. You can view specific product certification information on the product details page or contact our customer service to obtain copies of certification certificates.</p>
            `,
            ja: `
                <p>はい、当社の製品はFSC認証、ISO 14001環境マネジメントシステム認証、中国環境ラベル製品認証など、国内外の複数の環境認証を取得しています。製品詳細ページで特定の製品の認証情報を確認するか、カスタマーサービスに連絡して認証書のコピーを入手できます。</p>
            `,
            Russian: `
                <p>是的，我们的产品已获得多项国内外环保认证，包括FSC认证、ISO 14001环境管理体系认证、中国环境标志产品认证等。您可以在产品详情页查看具体产品的认证信息，或联系我们的客服获取认证证书副本。</p>
            `,
            Malay: `
                <p>是的，我们的产品已获得多项国内外环保认证，包括FSC认证、ISO 14001环境管理体系认证、中国环境标志产品认证等。您可以在产品详情页查看具体产品的认证信息，或联系我们的客服获取认证证书副本。</p>
            `
        },
        isActive: false,
        answerHeight: 0
    },
    {
        question: {
            zh: '公司是否接受参观考察？',
            en: 'Does the company accept visits and inspections?',
            ja: '会社の見学や視察は可能ですか？',
            Russian: '公司是否接受参观考察？',
            Malay: '公司是否接受参观考察？'
        },
        answer: {
            zh: `
                <p>我们欢迎客户、合作伙伴和相关机构前来参观考察。为保证参观质量和安全，请提前至少3个工作日与我们联系预约，邮箱：ybzy@yb-zy.com，或电话：0831-3309663。</p>
            `,
            en: `
                <p>We welcome customers, partners, and relevant organizations to visit and inspect our facilities. To ensure the quality and safety of visits, please contact us at least 3 business days in advance to make an appointment. Email: ybzy@yb-zy.com, or phone: 0831-3309663.</p>
            `,
            ja: `
                <p>お客様、パートナー、関連機関の見学や視察を歓迎いたします。見学の質と安全性を確保するため、少なくとも3営業日前までにご連絡ください。メール：ybzy@yb-zy.com、または電話：0831-3309663。</p>
            `,
            Russian: `
                <p>我们欢迎客户、合作伙伴和相关机构前来参观考察。为保证参观质量和安全，请提前至少3个工作日与我们联系预约，邮箱：ybzy@yb-zy.com，或电话：0831-3309663。</p>
            `,
            Malay: `
                <p>我们欢迎客户、合作伙伴和相关机构前来参观考察。为保证参观质量和安全，请提前至少3个工作日与我们联系预约，邮箱：ybzy@yb-zy.com，或电话：0831-3309663。</p>
            `
        },
        isActive: false,
        answerHeight: 0
    }
])

const answerRefs = ref<HTMLElement[]>([])

// FAQ切换功能
const toggleFaq = (index: number) => {
    // 关闭其他打开的FAQ
    faqs.value.forEach((item, i) => {
        if (i !== index && item.isActive) {
            item.isActive = false
            item.answerHeight = 0
        }
    })
    
    // 切换当前FAQ
    const currentFaq = faqs.value[index]
    currentFaq.isActive = !currentFaq.isActive
    
    if (currentFaq.isActive) {
        // 使用nextTick确保DOM已更新
        nextTick(() => {
            const answerElement = answerRefs.value[index]
            if (answerElement) {
                currentFaq.answerHeight = answerElement.scrollHeight
            }
        })
    } else {
        currentFaq.answerHeight = 0
    }
}

// 表单提交处理
const handleSubmit = async () => {
    isSubmitting.value = true
    
    try {
        // 这里添加表单提交逻辑
        const response = await fetch('http://localhost:3000/api/contact', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData.value)
        })
        
        const data = await response.json()
        
        if (data.success) {
            showMessage('表单提交成功！我们会尽快与您联系。', 'success')
            formData.value = {
                name: '',
                company: '',
                email: '',
                phone: '',
                subject: '',
                message: ''
            }
        } else {
            showMessage(data.message || '提交失败，请稍后重试。', 'error')
        }
    } catch (error) {
        console.error('提交表单时出错:', error)
        showMessage('提交时出现错误，请稍后重试。', 'error')
    } finally {
        isSubmitting.value = false
    }
}

// 显示消息提示
const showMessage = (message: string, type: string = 'info') => {
    // 这里可以添加消息提示组件的实现
    console.log(`${type}: ${message}`)
}

// 平滑滚动功能
onMounted(() => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    })

    document.querySelectorAll('.smooth-scroll').forEach(anchor => {
        anchor.addEventListener('click', function(this: HTMLElement, e: Event) {
            e.preventDefault()
            
            const targetId = this.getAttribute('href')
            const targetElement = document.querySelector(targetId || '') as HTMLElement
            
            if (targetElement) {
                window.scrollTo({
                    top: targetElement.offsetTop - 100,
                    behavior: 'smooth'
                })
            }
        })
    })
})
</script>

<style scoped>
/* 移除所有自定义样式，因为已经使用 Tailwind CSS 类替换 */
</style> 